<template>
  <div>
    <Toast position="top-right"></Toast>
    <ConfirmDialog></ConfirmDialog>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Upload</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Upload</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <form>
              <label id="font1">Upload to</label>
              <dir class="row">
                <div class="col-4">
                  <div class="form-group m-b-40">
                    <Dropdown
                      v-model="selectedUploadType"
                      :options="uploadTypes"
                      optionLabel="name"
                      placeholder="Select upload type"
                      style="width: 100%"
                    />
                  </div>
                </div>

                <div class="col-2">
                  <Button
                  class="btn-info"
                  style="width: 100px"
                    label="Go"
                    @click="goButtonPressed()"
                    v-if="showGoButton()"
                  />
                </div>
              </dir>
            </form>
          </div>
        </div>

        <!-- -- Get File -->
        <div
          class="card"
          style="padding: 40px 40px 40px 40px"
          v-if="showFileUpload"
        >
          <h3>Upload Here</h3>
          <FileUpload
            mode="advanced"
            name="demo[]"
            :chooseLabel="'Choose file'"
            accept=".csv"
            :multiple="false"
            :auto="true"
            :customUpload="true"
            @uploader="fileUploader"
            @clear="clearFilesSelection()"
          />
        </div>

        <!-- -- Mapping -->
        <div class="card" v-if="showMappingPanel">
          <div class="row">
            <div
              class="col-12 text-right"
              style="padding-top: 40px; padding-right: 50px"
            >
              <Button label="Finalize" @click="finalizeButtonPressed()" />
            </div>
          </div>

          <div class="table-responsive" style="padding: 40px 40px 40px 40px">
            <table
              class="table display table-bordered table-striped no-wrap"
              id="home_2"
            >
              <thead class="thead-dark">
                <tr>
                  <th>Name</th>
                  <th>Mapping</th>
                  <th>Sample First Row</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(pf, ndx01) in zeroline" :key="ndx01">
                  <td v-if="pf.name !== ''">
                    {{ pf }}
                  </td>
                  <td>
                 
                    <!-- @change="mappedOptionChanged(ndx01)" -->
                    <Dropdown
                      v-model="selectedFields[ndx01]"
                      :options="fileHeaderFieldsObj"
                      optionLabel="columnHeading"
                      placeholder="Select field"
                      style="width: 100%"
                    />
                  </td>
                  <td>{{ getSampleFieldText(ndx01) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- -- History -->
        <h2 style="padding: 10px 0px 0px 10px"><strong>History</strong></h2>
        <div class="card">
          <div class="row"></div>

          <div class="table-responsive" style="padding: 40px 40px 40px 40px">
            <div>
              <DataTable 
                stripedRows headerStyle="text-align: center"
                class="p-datatable-customers"
                :lazy="true"
                :rowHover="true"
                :loading="loading"
                :value="uploadHistoryList"
                :paginator="true"
                :rows="10"
                :totalRecords="totalrows"
                @page="onPage($event)"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50, 100]"
                responsiveLayout="scroll"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              >
                <ColumnGroup type="header">
                  <Column field="createdAt" header="Created At">
                    <template #body="slotProps">
                      {{ showHistDate(slotProps.data.createdAt) }}
                    </template>
                  </Column>
                </ColumnGroup>

                <Column field="createdBy" header="Uploaded By"></Column>
                <Column header="Skipped Rows">
                  <template #body="slotProps">
                    <div align="left">
                      {{ slotProps.data.skippedRows }}
                    </div>
                  </template></Column
                >

                <Column header="Uploaded Rows">
                  <template #body="slotProps">
                    <div align="left">
                      {{ slotProps.data.uploadedRows }} / {{ slotProps.data.totalRows }}
                    </div>
                  </template></Column
                >

               <Column field="uploadedFileUrl" header="Original File">
                  <template #body="slotProps">
                    <a v-if="slotProps.data.totalRows == '-'"
                    >{{
                      slotProps.data.uploadedFile
                    }}</a>
                    <a v-else
                     :href="`${slotProps.data.uploadedFileUrl}`" download>{{
                      slotProps.data.uploadedFile
                    }}</a>
                  </template>
                </Column>

                <Column field="errorFileUrl" header="Error File">
                  <template
                   #body="slotProps">
                    <a v-if="slotProps.data.totalRows == '-'">{{
                      slotProps.data.errorFile
                    }}</a>
                    <a v-else
                      :href="`${slotProps.data.errorFileUrl}`" download>{{
                      slotProps.data.errorFile
                    }}</a>
                  </template>
                </Column>

              </DataTable>
            </div>

            <!-- <table
              class="
                table
                display
                table-bordered table-striped
                no-wrap
                text-center
              "
              id="table0012"
            >
              <thead class="thead-dark">
                <tr>
                  <th>Created At</th>
                  <th>Name</th>
                  <th>Uploaded File</th>
                  <th>Error File</th>
                  <th>Uploaded Summary</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(pf, ndx01) in uploadHistoryList" :key="ndx01">
                  <td>{{ showHistDate(pf.createdAt) }}</td>
                  <td>{{ pf.createdBy }}</td>
                  <td>
                    <a :href="`${pf.uploadedFileUrl}`" download>{{
                      pf.uploadedFile
                    }}</a>
                  </td>
                  <td>
                    <a :href="`${pf.errorFileUrl}`" download>{{ pf.errorFile }}</a>
                  </td>
                  <td>{{ pf.uploadSummary }}</td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import localMixin from "./UploadPatients";

export default {
  name: "UploadPatients",
  mixins: [localMixin],
  components: {},

  data() {
    return {
      //timer set
      TimerObject: {},
      loading: false,
      showMappingPanel: false,
      showFileUpload: false,

      pagerows:10,
      totalrows:0,

      fileDataString: "",
      fileHeaderFields: [],
      firstLine: [],
      fileHeaderFieldsObj: [],

      uploadHistoryList: [],

      fileUploadKount: 1,
      csvFile: "",
      zeroline: [],

      selectedUploadType: "",
      uploadTypes: [
        { name: "Patient Portal", code: "PP" },
        // { name: "Payments", code: "PY" },
        // { name: "Records", code: "RE" },
        // { name: "Visits", code: "VI" },
        // { name: "Paris", code: "PRS" },
      ],

      selectedFields: [],
      selectedFields_Copy: [],
      patientFields: [     
        {
          name: "External ID",
          dbColumn: "ExternalId",
          sample: "",
          mandatory: false,
          id: 0,
        },
        {
          name: "First Name",
          dbColumn: "FirstName",
          sample: "",
          mandatory: true,
          id: 1,
        },
        {
          name: "Last Name",
          dbColumn: "LastName",
          sample: "",
          mandatory: true,
          id: 2,
        },
        {
          name: "DOB",
          dbColumn: "DOB",
          sample: "",
          mandatory: true,
          id: 3,
        },
        {
          name: "Gender",
          dbColumn: "Gender",
          sample: "",
          mandatory: true,
          id: 4,
        },
        {
          name: "Social Security Number",
          dbColumn: "SSN",
          sample: "",
          mandatory: false,
          id: 5,
        },
        {
          name: "Phone Number",
          dbColumn: "Phone",
          sample: "",
          mandatory: false,
          id: 6,
        },
        {
          name: "Email",
          dbColumn: "Email",
          sample: "",
          mandatory: false,
          id: 7,
        },
        {
          name: "Street",
          dbColumn: "StreetAddress",
          sample: "",
          mandatory: false,
          id: 8,
        },
        {
          name: "City",
          dbColumn: "City",
          sample: "",
          mandatory: false,
          id: 9,
        },
        {
          name: "State",
          dbColumn: "State",
          sample: "",
          mandatory: false,
          id: 10,
        },
        {
          name: "Zip",
          dbColumn: "Zip",
          sample: "",
          mandatory: false,
          id: 11,
        },
        {
          name: "Primary Insurance Name",
          dbColumn: "pInsuranceName",
          sample: "",
          mandatory: false,
          id: 12,
        },
        {
          name: "Primary Insurance Number",
          dbColumn: "pInsuranceNo",
          sample: "",
          mandatory: false,
          id: 13,
        },
        {
          name: "Primary Insurance Group ID",
          dbColumn: "pInsuranceGroupId",
          sample: "",
          mandatory: false,
          id: 14,
        },
        {
          name: "Secondary Insurance Name",
          dbColumn: "sInsuranceName",
          sample: "",
          mandatory: false,
          id: 15,
        },
        {
          name: "Secondary Insurance Number",
          dbColumn: "sInsuranceNo",
          sample: "",
          mandatory: false,
          id: 16,
        },
        {
          name: "Secondary Insurance Group ID",
          dbColumn: "sInsuranceGroupId",
          sample: "",
          mandatory: false,
          id: 17,
        },
    
        
      ],
    };
  }, // data
};
</script>

<style lang="scss" scoped>
::v-deep(.p-paginator) {
  .p-paginator-current {
    margin-left: auto;
  }
}
::v-deep(.p-progressbar) {
  height: 0.5rem;
  background-color: #d8dadc;
  .p-progressbar-value {
    background-color: #607d8b;
  }
}
::v-deep(.p-datepicker) {
  min-width: 25rem;
  td {
    font-weight: 400;
  }
}
::v-deep(.p-datatable.p-datatable-customers) {
  .p-datatable-header {
    padding: 1rem;
    text-align: center;
    font-size: 1.5rem;
  }
  .p-paginator {
    padding: 1rem;
  }
  .p-paginator .p-paginator-pages .p-paginator-page {
    background-color: transparent;
    border: 1px;
    border-color: dimgray;
    color: #495057;
    min-width: 2.357rem;
    height: 2.357rem;
    margin: 0.143rem;
    box-shadow: none;
    border-radius: 0px;
  }
  .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    background: darkorange;
    border: 1px;
    // border-color: darkorange;
    color: white;
  }
  .p-datatable-thead > tr > th {
    text-align: center;
    background-color: #000000;
    color: white;
    font-weight: 700;
  }
  .p-datatable-tbody > tr > td {
    cursor: auto;
  }
  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}
</style>